module.exports = __webpack_public_path__ + "media/assets/images/hamster-be7c6c2fd277b10e30ce40f88edd04b4.gif";